import { createAction } from "@reduxjs/toolkit";

export const setFaqError = createAction<string | null>("faq/setError");
